export function convertJpgToPng(jpgUrl) {
    return new Promise((resolve, reject) => {
      var img = new Image()

      img.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height

        var ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)

        // Convert the image to PNG format
        var pngDataUrl = canvas.toDataURL('image/png')

        // Resolve the promise with the converted PNG URL
        resolve(pngDataUrl)
      }

      // Handle image loading errors
      img.onerror = function () {
        reject(new Error('Could not load the image at the provided URL.'))
      }

      img.crossOrigin = 'Anonymous'
      img.src = jpgUrl
    })
  }